import React, { FunctionComponent } from 'react';

const PlayResultsPage: FunctionComponent = () => {
  return <div>Play results</div>;
};

export default PlayResultsPage;
